import React from 'react'
import CloseIcon from '@material-ui/icons/Close'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import {IconButton} from '@material-ui/core'
import {useParams} from 'react-router'
import {ReservationConfigurationContext} from '../../../context/ReservationConfiguration'
import OptionList from './OptionList'
import LoadingIndicator from '../LoadingIcon'

const RootClass = 'mod-action-steps'
const ActionStepRow = ({
  data,
  actions,
  onChangeField = (e, action_id, field) => {},
  onClickDelete = e => {},
}) => {
  const {group_id} = useParams()
  const {groupActionFields, getGroupActionFields} = React.useContext(
    ReservationConfigurationContext
  )

  const refFieldBox = React.useRef(null)
  const [open, setOpen] = React.useState(false)
  const fieldValueKey = `${group_id}_${data.action_id}`

  const action = actions.find(a => a.id === data.action_id)
  const field = groupActionFields.data[fieldValueKey]?.find(
    f => f.id === data.return_field_data?.id
  )

  const handleClickOpen = e => {
    setOpen(true)
    if (!!!groupActionFields.data[fieldValueKey]) {
      getGroupActionFields({group_id: group_id, action_id: data.action_id, action_types: true})
    }
  }

  const handleChange = (e, field) => {
    onChangeField(e, data.action_id, field)
    setOpen(false)
  }

  // use Effect
  React.useEffect(() => {
    if (data.return_field_data && !!!groupActionFields.data[fieldValueKey]) {
      getGroupActionFields({group_id: group_id, action_id: data.action_id, action_types: true})
    }
  }, [data, group_id, getGroupActionFields, groupActionFields.data, fieldValueKey])

  return (
    <div className={`c-res-mod ${RootClass}__row`}>
      <div className={`${RootClass}__row-action ap-typography`}>{action?.name}</div>
      <div
        ref={refFieldBox}
        className={`${RootClass}__row-field ap-typography`}
        onClick={handleClickOpen}
      >
        <span style={{flex: 1}}>
          {!field && 'Select Reserved Field'}
          {field && field.name}
        </span>
        <ExpandMoreIcon
          style={{
            marginRight: 8,
          }}
        />
      </div>
      <div className={`${RootClass}__row-cta`} onClick={onClickDelete}>
        <IconButton size="small">
          <CloseIcon />
        </IconButton>
      </div>

      <OptionList
        anchorEl={refFieldBox.current}
        open={open}
        onClose={() => setOpen(false)}
        loading={groupActionFields.isLoading}
        data={groupActionFields.data[fieldValueKey] || []}
        onChange={handleChange}
        value={data.return_field_data}
      />
    </div>
  )
}

export default ActionStepRow
